import {
  type HypernovaIconName,
  hypernovaIconNames,
} from '@opallabs/constellation'
import { Color } from '@opallabs/gem'
import { getColor } from '@opallabs/kuiper'
import { SearchResource } from '../types'

const typeIconMap = new Map([
  ['board', 'gem-grid'],
  ['moment', 'moment'],
  ['post', 'content'],
  ['story', 'story'],
  ['asset_reference', 'file'],
  ['user', 'person'],
])

export const iconForEntity = (data: SearchResource): string | undefined => {
  const { post_service_system_name: postServiceSystemName, type } = data

  if (type === 'post') {
    if (!postServiceSystemName) return 'file'
    const iconName = `channel-${postServiceSystemName}-14` as HypernovaIconName
    return hypernovaIconNames[iconName] ? iconName : 'file'
  }

  return typeIconMap.get(type)
}

export const getColorStyles = (color?: string): string | undefined => {
  if (!color) return Color.light.Text.Gray

  // Pulsar has several named colors, so we'll check for those first
  const pulsarColor = getColor(color)
  if (pulsarColor) return pulsarColor

  // Colors returning from the database are often formatted as hex, but
  // don't start with the leading hash
  return /^#/.test(color) ? color : `#${color}`
}
